import React from 'react';
import { buildSessionTabs } from './sessionTabConfig';

/**
 * Tab bar for competitive session: Courts, Manage (optional), Session Ranking, Player Ranking (optional), Games.
 * Shown above session content on all viewports — horizontal scroll on narrow screens.
 */
export default function SessionTabBar({
  activeTab,
  onTabChange,
  isSessionHost,
  isAdmin,
  showManageTab = false,
  showYouTab = false,
  showRankingTab = true,
  showPlayerRankingTab = true,
  className = '',
}) {
  const tabs = buildSessionTabs({
    showManageTab,
    isSessionHost,
    isAdmin,
    showYouTab,
    showRankingTab,
    showPlayerRankingTab,
  });
  const liveTabs = tabs.filter((tab) => ['courts', 'manage'].includes(tab.id));
  const insightTabs = tabs.filter((tab) => !['courts', 'manage'].includes(tab.id));

  const renderTabButton = (tab) => (
    <button
      key={tab.id}
      type="button"
      onClick={() => onTabChange(tab.id)}
      aria-current={activeTab === tab.id ? 'page' : undefined}
      className={`shrink-0 whitespace-nowrap rounded-md px-2 py-1.5 text-[11px] font-medium transition-colors sm:px-2.5 sm:text-xs md:px-3 md:text-sm ${
        activeTab === tab.id
          ? 'bg-primary text-text-inverse shadow-brand-sm'
          : 'text-text-secondary hover:bg-surface-subtle hover:text-text-primary'
      }`}
    >
      <span className="lg:hidden">{tab.mobileLabel ?? tab.label}</span>
      <span className="hidden lg:inline">{tab.label}</span>
    </button>
  );

  return (
    <div className={className}>
      <div
        className="overflow-x-auto scrollbar-hide touch-pan-x -mx-0.5 px-0.5"
        role="navigation"
        aria-label="Session sections"
      >
        <div className="inline-flex min-w-max max-w-full flex-nowrap items-center gap-1 p-1 rounded-lg bg-surface border border-border-medium shadow-brand-sm sm:flex-wrap sm:gap-x-2 sm:gap-y-2">
          <span className="hidden pl-2 text-[11px] font-semibold uppercase tracking-wide text-text-muted sm:inline">
            Live
          </span>
          <div className="flex flex-nowrap items-center gap-1 sm:flex-wrap">
            {liveTabs.map(renderTabButton)}
          </div>
          <span
            className="mx-0.5 hidden h-5 w-px shrink-0 bg-border-medium min-[420px]:inline sm:mx-0 sm:h-6"
            aria-hidden
          />
          <span className="hidden pl-1 text-[11px] font-semibold uppercase tracking-wide text-text-muted sm:inline">
            Insights
          </span>
          <div className="flex flex-nowrap items-center gap-1 sm:flex-wrap">
            {insightTabs.map(renderTabButton)}
          </div>
        </div>
      </div>
    </div>
  );
}
